import './Bestsellers.css';
import SliderElement from "./sub/SliderElement/SliderElement.jsx";
import {useEffect, useRef, useState} from "react";
import {useMediaQuery} from "react-responsive";
import {fetchBestsellersBrief} from "../../../../ProductsHandler.js";

export default function Bestsellers() {
    const [firstImageIndex, setFirstImageIndex] = useState(0);
    const startX = useRef(0);
    const isDragging = useRef(false);
    const isMobile = useMediaQuery({maxWidth: 768});
    const [bestsellers,setBestsellers] = useState([]);

    const fetchBestsellers = async () => {

        const data = await fetchBestsellersBrief();

        setBestsellers(data);

    }



    useEffect(() => {
        fetchBestsellers();

    }, []);

    const manageSlider = (direction) => {
        const maxMove=isMobile ? 2 : 4;
        setFirstImageIndex(prevIndex => {
            if (direction === "prev" && prevIndex > 0) return prevIndex - 1;
            if (direction === "next" && prevIndex < bestsellers.length - maxMove) return prevIndex + 1;
            return prevIndex;
        });
    };

    const handleMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.clientX || e.touches[0].clientX;
    };

    const handleMouseMove = (e) => {
        if (!isDragging.current) return;
        const currentX = e.clientX || e.touches[0].clientX;
        const difference = startX.current - currentX;

        if (difference > 50) {
            manageSlider("next");
            isDragging.current = false;
        } else if (difference < -50) {
            manageSlider("prev");
            isDragging.current = false;
        }
    };

    const handleMouseUp = () => {
        isDragging.current = false;
    };

    return (
        <div id='bestsellers'>
            <span id='bestsellers-label'>BESTSELLERY</span>
            <div id='bestsellers-slider'
                 onMouseDown={handleMouseDown}
                 onMouseMove={handleMouseMove}
                 onMouseUp={handleMouseUp}
                 onMouseLeave={handleMouseUp}
                 onTouchStart={handleMouseDown}
                 onTouchMove={handleMouseMove}
                 onTouchEnd={handleMouseUp}>
                {bestsellers.map((bestseller, index) => (
                    <SliderElement key={index} element={bestseller} style={{ transform: `translateX(${firstImageIndex * -110}%)` }} />
                ))}
            </div>
            <div id='bestsellers-slider-bttns'>
                <div id='bestsellers-slider-bttn-left'
                     className='bestsellers-navigation-bttn'
                     onClick={() => manageSlider('prev')}
                     >
                    <img loading="lazy" src={firstImageIndex===0 ? '/images/arrow-icon-inactive.webp' : '/images/arrow-icon.webp'} alt=""/>
                </div>
                <div id='bestsellers-slider-bttn-right'
                     className='bestsellers-navigation-bttn'
                     onClick={() => manageSlider('next')}>
                    <img loading="lazy" src={firstImageIndex===bestsellers.length-4 ? '/images/arrow-icon-inactive.webp' : '/images/arrow-icon.webp'} alt=""/>
                </div>
            </div>
        </div>
    );
}
